import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 5888AA23-7D87-46D3-83F3-1AB820E9F77D
 * name music-note-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-note-outline.svg
 * tags
 * - Music 
 */
export const MusicNoteOutlineIcon = createSvgIcon(<><path d="M12 3V13.55A4 4 0 1 0 14 17V7H18V3M10 19A2 2 0 1 1 12 17A2 2 0 0 1 10 19Z" /></>, 'MusicNoteOutlineIcon');
export default MusicNoteOutlineIcon